// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7810":"css/contact_us/machship-style","8252":"css/app"}[chunkId] + ".css";
};